import { render, staticRenderFns } from "./PinnacleTable.vue?vue&type=template&id=15c57fe8&scoped=true&"
import script from "./PinnacleTable.vue?vue&type=script&lang=js&"
export * from "./PinnacleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c57fe8",
  null
  
)

export default component.exports